<div *ngFor='let notification of notifications; let i = index'>
  <div *ngIf='!notification.dismissed' class="notification-panel flex-fill">
    <ukg-banner [inline]="true" [noMaxWidth]="true" [type]="userMessages[notification.key].severity" class="flex-auto">
      <span data-automation="notification_message">{{userMessages[notification.key].message | translate:
        notification.params}}</span>
      <div slot="end">
        <ukg-button aria-label="banner-action-1" [emphasis]="'low'"
          class="btn btn-link btn-notification flex-fixed"
          (click)="dismiss(i)" data-automation="dismiss-notification-btn"
          translate>
          COMMON.BUTTON_DISMISS
        </ukg-button>
      </div>
    </ukg-banner>
  </div>
</div>